module.exports = __webpack_public_path__ + "static/media/winged hat.96b326b9.png";